import "../Css/Fairepart.css"


export default function Fairepart() {

  return (
    
    <div id="Fairepart" className='faire-part-container'>
        <img alt="faire-part-logo" className="fairepart-logo" src="./Images/Icons/Logo-Fairepart.png"></img>
        <img alt="fairepart-date" className="fairepart-date" src="./Images/Icons/Fairepart-date.png"></img>
        <img alt="fairepart-infos" className="fairepart-infos" src="./Images/Icons/Fairepart-icons.png"></img>
        {/* <img className="fairepart-image"src="./Images/Icons/Fairepart-2.jpg"></img> */}
    </div>
    
  );
}